import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      locale: 'locale/GET_LOCALE'
    }),
    isKorean () {
      return this.locale === 'ko'
    }
  }
}
